// import React, { useState, useEffect } from "react";
export default function Wedding() {
  return (
    <img
      className="svg_lifeline"
      src="/svg/wedding.svg"
      alt=""
    />
  );
}
